module.exports = __webpack_public_path__ + "img/FORASTEIRO.fdf2ba64.jpg";